// src/Header.js
import React from 'react';
import { Link, useLocation } from 'react-router';
import './Header.css';
import { STORAGE_KEYS } from './v2Api';

const Header = ({ user, handleSignOut, onSignIn }) => {
  const location = useLocation();
  const isPicksOpen = location.pathname === '/picks';
  const activeContextId = localStorage.getItem(STORAGE_KEYS.devContextId);
  const activeContextName = localStorage.getItem(STORAGE_KEYS.devContextName);

  return (
    <div className="header">
      <div className="header-content">
        <div className="left-content">
          <Link to="/" className="service-link" alt="Naviguesser">
            <img src="/favicon-32x32.png" alt="logo" className="favicon" />
            Naviguesser
          </Link>
          {activeContextId && (
            <span data-testid="active-trip-indicator" style={{ fontSize: '0.75em', color: 'var(--c-accent)', marginRight: 12 }}>
              [{activeContextName || activeContextId}]
            </span>
          )}
          <span>
            <Link to={isPicksOpen ? '/options' : '/picks'} alt="my picks">
              {isPicksOpen ? '🔍 Explore' : '📋 My Picks'}
            </Link>
          </span>
        </div>
        {user && !user.isAnonymous ? (
          <div className="right-content">
            <span>Hi, {user.email || user.displayName || "User"}! </span>
            <button onClick={handleSignOut} className="secondary-button">Sign Out</button>
          </div>
        ) : (
          <div className="right-content">
            <span>Hi, guest!</span>
            {onSignIn && (
              <button onClick={onSignIn} className="secondary-button" data-testid="header-sign-in">
                Sign in
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
